import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ConfigurationService } from '@sc/data-access-configuration';
import { AuthService } from '@sc/feature-auth-okta';
import { FitterRouterService } from '@sc/feature-fitter-path-router-system';
import { combineLatest, map, take } from 'rxjs';

export const PlanningContainerGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const configurationService = inject(ConfigurationService);
  const fitterRouterService = inject(FitterRouterService);

  return combineLatest([
    authService.isAuthenticated$(),
    authService.userIsFitter$(),
    authService.userHasFitterPlanningOktaAccess$(
      configurationService.getConfig().id
    ),
    fitterRouterService.getRedirectRoute(),
  ]).pipe(
    take(1),
    map(([isAuth, isFitter, isFitterPlanningAccessX, redirectUrl]) =>
      isAuth && isFitter && isFitterPlanningAccessX
        ? true
        : state?.url
        ? router.createUrlTree([redirectUrl], {
            queryParams: { previousUrl: state.url },
          })
        : router.parseUrl(redirectUrl)
    )
  );
};
